import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "trip-header" }
const _hoisted_2 = { class: "trip-breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = { class: "breadcrumb-id" }
const _hoisted_6 = { class: "main-grid" }
const _hoisted_7 = { class: "left-column" }
const _hoisted_8 = { class: "info-card renter-card" }
const _hoisted_9 = { class: "renter-info-left" }
const _hoisted_10 = { class: "renter-name" }
const _hoisted_11 = { class: "renter-phone" }
const _hoisted_12 = {
  key: 0,
  class: "renter-badge"
}
const _hoisted_13 = { class: "info-card vehicle-card" }
const _hoisted_14 = { class: "vehicle-image" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  src: "https://via.placeholder.com/160x100",
  alt: "Golf Cart"
}
const _hoisted_17 = { class: "vehicle-details" }
const _hoisted_18 = { class: "vehicle-name" }
const _hoisted_19 = { class: "vehicle-model" }
const _hoisted_20 = { class: "info-card timeline-card" }
const _hoisted_21 = { class: "pricing-badge" }
const _hoisted_22 = { class: "timeline-grid" }
const _hoisted_23 = { class: "timeline-col" }
const _hoisted_24 = { class: "timeline-label" }
const _hoisted_25 = { class: "timeline-val" }
const _hoisted_26 = { class: "timeline-time" }
const _hoisted_27 = { class: "timeline-col" }
const _hoisted_28 = { class: "timeline-label" }
const _hoisted_29 = { class: "timeline-val" }
const _hoisted_30 = { class: "strikethrough" }
const _hoisted_31 = { class: "highlighted" }
const _hoisted_32 = { class: "timeline-time" }
const _hoisted_33 = { class: "strikethrough" }
const _hoisted_34 = { class: "highlighted" }
const _hoisted_35 = {
  key: 0,
  class: "extension-label"
}
const _hoisted_36 = {
  key: 0,
  class: "alert-box"
}
const _hoisted_37 = { class: "alert-content" }
const _hoisted_38 = {
  key: 1,
  class: "stall-info",
  style: {"margin-top":"16px","font-size":"14px","color":"#64748b"}
}
const _hoisted_39 = { class: "info-card action-buttons-card" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "info-card audit-card" }
const _hoisted_44 = { class: "audit-header" }
const _hoisted_45 = { class: "audit-title" }
const _hoisted_46 = { class: "audit-protocol" }
const _hoisted_47 = { class: "audit-body" }
const _hoisted_48 = { class: "audit-col" }
const _hoisted_49 = { class: "audit-subtitle" }
const _hoisted_50 = {
  key: 0,
  class: "audit-images"
}
const _hoisted_51 = {
  key: 1,
  class: "audit-images empty"
}
const _hoisted_52 = { class: "audit-col" }
const _hoisted_53 = { class: "audit-subtitle" }
const _hoisted_54 = {
  key: 0,
  class: "audit-images"
}
const _hoisted_55 = {
  key: 1,
  class: "audit-images empty"
}
const _hoisted_56 = { class: "right-column" }
const _hoisted_57 = {
  key: 0,
  class: "info-card settlement-card"
}
const _hoisted_58 = { class: "settlement-header" }
const _hoisted_59 = { class: "settlement-title" }
const _hoisted_60 = { class: "settlement-desc" }
const _hoisted_61 = { class: "trip-id-small" }
const _hoisted_62 = { class: "settlement-row" }
const _hoisted_63 = {
  key: 0,
  class: "settlement-row"
}
const _hoisted_64 = {
  key: 1,
  class: "settlement-row discount"
}
const _hoisted_65 = { class: "settlement-row total" }
const _hoisted_66 = { class: "settlement-row" }
const _hoisted_67 = { class: "settlement-due cash-due" }
const _hoisted_68 = { class: "due-label" }
const _hoisted_69 = { class: "due-amount" }
const _hoisted_70 = { class: "operations-section" }
const _hoisted_71 = { class: "operation-type" }
const _hoisted_72 = { class: "table-actions" }
const _hoisted_73 = { class: "finish-payment credit-card-finish" }
const _hoisted_74 = { class: "payment-row" }
const _hoisted_75 = { class: "payment-field half-width" }
const _hoisted_76 = { class: "payment-label" }
const _hoisted_77 = { class: "payment-field half-width" }
const _hoisted_78 = { class: "payment-label" }
const _hoisted_79 = { class: "payment-row" }
const _hoisted_80 = { class: "payment-field full-width" }
const _hoisted_81 = { class: "payment-label" }
const _hoisted_82 = { class: "payment-action-pills" }
const _hoisted_83 = {
  key: 1,
  class: "info-card settlement-card"
}
const _hoisted_84 = { class: "settlement-header" }
const _hoisted_85 = { class: "settlement-title" }
const _hoisted_86 = { class: "settlement-desc" }
const _hoisted_87 = { class: "trip-id-small" }
const _hoisted_88 = { class: "settlement-row" }
const _hoisted_89 = {
  key: 0,
  class: "settlement-row discount"
}
const _hoisted_90 = { class: "settlement-row total" }
const _hoisted_91 = { class: "settlement-row" }
const _hoisted_92 = { class: "settlement-due credit-due" }
const _hoisted_93 = { class: "due-label" }
const _hoisted_94 = { class: "due-amount" }
const _hoisted_95 = { class: "operations-section" }
const _hoisted_96 = { class: "operation-type" }
const _hoisted_97 = { class: "table-actions" }
const _hoisted_98 = { class: "finish-payment credit-card-finish" }
const _hoisted_99 = { class: "payment-row" }
const _hoisted_100 = { class: "payment-field half-width" }
const _hoisted_101 = { class: "payment-label" }
const _hoisted_102 = { class: "payment-field half-width" }
const _hoisted_103 = { class: "payment-label" }
const _hoisted_104 = { class: "payment-row" }
const _hoisted_105 = { class: "payment-field full-width" }
const _hoisted_106 = { class: "payment-label" }
const _hoisted_107 = { class: "payment-action-pills" }
const _hoisted_108 = { class: "discount-dialog" }
const _hoisted_109 = { class: "new-discount" }
const _hoisted_110 = { class: "new-discount-form" }
const _hoisted_111 = { class: "existing-discounts" }
const _hoisted_112 = { class: "section-header" }
const _hoisted_113 = {
  key: 0,
  class: "discounts-loading"
}
const _hoisted_114 = {
  key: 2,
  class: "discounts-list"
}
const _hoisted_115 = { class: "discount-chip" }
const _hoisted_116 = { class: "chip-label" }
const _hoisted_117 = { class: "chip-amount" }
const _hoisted_118 = { class: "discount-info" }
const _hoisted_119 = { class: "discount-meta" }
const _hoisted_120 = {
  key: 0,
  class: "admin-row"
}
const _hoisted_121 = { class: "admin-value" }
const _hoisted_122 = {
  key: 1,
  class: "discount-reason"
}
const _hoisted_123 = { class: "reason-label" }
const _hoisted_124 = { class: "reason-text" }
const _hoisted_125 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","width":"100%"} }
const _hoisted_126 = { style: {"font-weight":"600","color":"#1e293b"} }
const _hoisted_127 = { style: {"color":"#64748b","font-size":"13px"} }
const _hoisted_128 = { style: {"font-size":"12px","color":"#94a3b8","margin-top":"6px"} }

import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRouter } from 'vue-router'
import {
  ChatLineSquare,
  User,
  Picture,
  ArrowRight,
  Location,
  Select,
  Edit,
  Right,
  WarningFilled,
  Money,
  Back
} from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useGolfTripsStore } from '@/store/golf-trips'
import { useGolfVehiclesStore } from '@/store/golf-vehicles'
import { useGolfI18n } from '@/composables/useGolfI18n'
import { formatDateWithTime } from '@/helpers/date'
import { extractErrorMessage } from '@/helpers/error-parsers'
import type {
  GolfTrip,
  GolfTransaction,
  GolfTripDiscount,
} from '@/api/golf'


export default /*@__PURE__*/_defineComponent({
  __name: 'GolfTripInfoSection',
  props: {
    trip: {}
  },
  emits: ["refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const router = useRouter()
const golfStore = useGolfTripsStore()
const golfVehiclesStore = useGolfVehiclesStore()
const { t, currentLanguage } = useGolfI18n()

const isApproving = ref(false)
const isDeclining = ref(false)
const isEnding = ref(false)
const isCancelling = ref(false)
const isHolding = ref(false)
const isUnholding = ref(false)
const isApplyingDiscount = ref(false)
const isChangingAsset = ref(false)

const declineDialogVisible = ref(false)
const declineReason = ref('')
const discountDialogVisible = ref(false)
const assetDialogVisible = ref(false)
const discountAmount = ref(0)
const discountReason = ref('')
const discounts = ref<GolfTripDiscount[]>([])
const loadingDiscounts = ref(false)
const removingDiscountId = ref<string | null>(null)
const selectedAssetId = ref('')

const transactionsDialogVisible = ref(false)
const loadingTransactions = ref(false)
const transactions = ref<GolfTransaction[]>([])
const paymentType = ref<'deposit' | 'service'>('deposit')
const paymentAction = ref<'charge' | 'freeze' | 'unfreeze' | 'refund' | 'collect' | 'return'>('charge')
const paymentAmount = ref('')
const processingPayment = ref(false)

const capitalize = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

const canApprove = computed(() => props.trip.status === 'pending')
const canDecline = computed(() => props.trip.status === 'pending' || props.trip.status === 'approved')
const canHold = computed(() => props.trip.status === 'ongoing')
const canUnhold = computed(() => props.trip.status === 'on_hold')
const canEnd = computed(() => ['ongoing', 'on_hold'].includes(props.trip.status))
const canCancel = computed(() =>
  ['pending', 'approved', 'ongoing', 'on_hold'].includes(props.trip.status)
)
const canApplyDiscount = computed(() =>
  ['ongoing', 'on_hold', 'approved'].includes(props.trip.status)
)
const canChangeAsset = computed(() =>
  ['pending', 'approved', 'ongoing', 'on_hold'].includes(props.trip.status)
)

const canManage = computed(
  () =>
    canApprove.value ||
    canDecline.value ||
    canHold.value ||
    canUnhold.value ||
    canEnd.value ||
    canCancel.value ||
    canApplyDiscount.value ||
    canChangeAsset.value
)

const availableAssets = computed(() => {
  const assets: any[] = []
  const profiles = golfVehiclesStore.profiles || []
  profiles.forEach((profile: any) => {
    if (profile.assets && profile.assets.length > 0) {
      profile.assets.forEach((asset: any) => {
        // Only active assets or the currently assigned asset can be selected
        if (
          asset.status === 'active' ||
          asset.id === (props.trip.asset?.id || props.trip.asset_id)
        ) {
          assets.push({
            ...asset,
            make_name: profile.name,
            label: `${asset.asset_number || '#' + asset.id.slice(0, 8)} (${profile.name}${asset.stall_number ? ' · ' + t('golf.trips.stall') + ' ' + asset.stall_number : ''})`,
          })
        }
      })
    }
  })
  return assets
})

const renterName = computed(() => {
  if (props.trip.renter?.first_name && props.trip.renter?.last_name) {
    return `${props.trip.renter.first_name} ${props.trip.renter.last_name}`
  }
  return props.trip.renter?.name || props.trip.user_id
})

const vehicleName = computed(() => {
  const profile = golfVehiclesStore.profiles.find(
    (p: any) => p.id === props.trip.golf_car_profile_id
  )
  return profile?.name || props.trip.profile?.name || props.trip.golf_car_profile_id
})

const vehicleImage = computed(() => {
  return (
    props.trip.profile?.images?.[0]?.secure_url ||
    golfVehiclesStore.profiles.find(
      (p: any) => p.id === props.trip.golf_car_profile_id
    )?.images?.[0]?.secure_url
  )
})

const totalDue = computed(() => {
  return props.trip.total_amount || 0
})

const creditCardData = computed(() => {
  const payment = props.trip.payment
  return [
    {
      type: 'Deposit',
      frozen: payment?.deposit_frozen_amount || 0,
      charged: payment?.deposit_charged_amount || 0,
      refunded: payment?.deposit_refunded_amount || 0,
    },
    {
      type: 'Service Fee',
      frozen: payment?.service_frozen_amount || 0,
      charged: payment?.service_charged_amount || 0,
      refunded: payment?.service_refunded_amount || 0,
    },
  ]
})

const pickupDate = computed(() => {
  const start = props.trip.trip_start_at || props.trip.reservation_start
  if (!start) return '—'
  return formatDateWithTime(start, 'MMM dd, yyyy')
})

const pickupTime = computed(() => {
  const start = props.trip.trip_start_at || props.trip.reservation_start
  if (!start) return '—'
  return formatDateWithTime(start, 'hh:mm a')
})

const hasExtension = computed(() => {
  return props.trip.extend_history && props.trip.extend_history.length > 0
})

// Scheduled end. Older hourly extensions didn't move reservation_end, so derive it from duration
const plannedEnd = computed(() => {
  const { pricing_type, trip_start_at, duration_minutes } = props.trip
  if (pricing_type === 'hourly' && trip_start_at && duration_minutes) {
    return new Date(
      new Date(trip_start_at).getTime() + duration_minutes * 60000
    ).toISOString()
  }
  return props.trip.reservation_end
})

// Extended trips compare scheduled ends; trip_end_at is the actual finish time
const displayedEnd = computed(() =>
  hasExtension.value
    ? plannedEnd.value || props.trip.trip_end_at
    : props.trip.trip_end_at || props.trip.reservation_end
)

const returnDate = computed(() => {
  const end = displayedEnd.value
  if (!end) return '—'
  return formatDateWithTime(end, 'MMM dd, yyyy')
})

const returnTime = computed(() => {
  const end = displayedEnd.value
  if (!end) return '—'
  return formatDateWithTime(end, 'hh:mm a')
})

const originalReturnDateTime = computed(() => {
  if (!hasExtension.value) return null
  const end = plannedEnd.value
  if (!end) return null
  let d = new Date(end)
  props.trip.extend_history!.forEach(ext => {
    if (ext.type === 'hourly' && ext.duration_minutes) {
      d = new Date(d.getTime() - ext.duration_minutes * 60000)
    } else if (ext.type === 'daily' && (ext as any).added_days) {
      d = new Date(d.getTime() - (ext as any).added_days * 24 * 60 * 60000)
    }
  })
  return d
})

const originalReturnDate = computed(() => {
  if (!originalReturnDateTime.value) return '—'
  return formatDateWithTime(originalReturnDateTime.value.toISOString(), 'MMM dd, yyyy')
})

const originalReturnTime = computed(() => {
  if (!originalReturnDateTime.value) return '—'
  return formatDateWithTime(originalReturnDateTime.value.toISOString(), 'hh:mm a')
})

const orderedAngles = ['front', 'back', 'left', 'right']

const pretripPhotos = computed(() => {
  const photos = props.trip.pretrip_photos || []
  return orderedAngles
    .map(angle => photos.find(p => p.angle === angle))
    .filter(Boolean) as { angle: string; url: string }[]
})

const aftertripPhotos = computed(() => {
  const photos = props.trip.aftertrip_photos || []
  return orderedAngles
    .map(angle => photos.find(p => p.angle === angle))
    .filter(Boolean) as { angle: string; url: string }[]
})

const pretripUrls = computed(
  () => props.trip.pretrip_photos?.map((p: any) => p.url).filter(Boolean) || []
)
const aftertripUrls = computed(
  () => props.trip.aftertrip_photos?.map((p: any) => p.url).filter(Boolean) || []
)

onMounted(async () => {
  golfVehiclesStore.fetchProfiles()
  await loadTransactions()
})

onBeforeUnmount(() => {
  if (typeof document !== 'undefined') {
    const portal = document.getElementById('golf-header-portal')
    if (portal) {
      portal.innerHTML = ''
    }
  }
})

const loadDiscounts = async () => {
  loadingDiscounts.value = true
  try {
    discounts.value = await golfStore.fetchTripDiscounts(props.trip.id)
  } finally {
    loadingDiscounts.value = false
  }
}

watch(
  () => discountDialogVisible.value,
  value => {
    if (value) {
      loadDiscounts()
    }
  }
)

const loadTransactions = async () => {
  loadingTransactions.value = true
  try {
    transactions.value = await golfStore.fetchTransactions({
      trip_id: props.trip.id,
    })
  } finally {
    loadingTransactions.value = false
  }
}

const formatDiscountDate = (dateStr: string) => {
  if (!dateStr) return '—'
  return formatDateWithTime(dateStr, 'MMM dd, yyyy HH:mm')
}

const removeDiscount = async (discountId: string) => {
  removingDiscountId.value = discountId
  try {
    const removed = await golfStore.removeTripDiscount(
      props.trip.id,
      discountId
    )
    if (removed) {
      await loadDiscounts()
      emit('refresh')
    }
  } finally {
    removingDiscountId.value = null
  }
}

const openChangeAssetDialog = () => {
  golfVehiclesStore.fetchProfiles()
  selectedAssetId.value = props.trip.asset?.id || props.trip.asset_id || ''
  assetDialogVisible.value = true
}

const handleApprove = async () => {
  isApproving.value = true
  try {
    const res = await golfStore.approveTrip(props.trip.id)
    if (res) {
      emit('refresh')
    }
  } finally {
    isApproving.value = false
  }
}

const openDeclineDialog = () => {
  declineReason.value = ''
  declineDialogVisible.value = true
}

const confirmDecline = async () => {
  isDeclining.value = true
  try {
    const res = await golfStore.declineTrip(
      props.trip.id,
      declineReason.value || undefined
    )
    if (res) {
      declineDialogVisible.value = false
      emit('refresh')
    }
  } finally {
    isDeclining.value = false
  }
}

const handleEnd = async () => {
  isEnding.value = true
  try {
    const res = await golfStore.endTrip(props.trip.id)
    if (res) {
      emit('refresh')
    }
  } finally {
    isEnding.value = false
  }
}

const confirmDiscount = async () => {
  if (discountAmount.value <= 0) {
    return
  }
  isApplyingDiscount.value = true
  try {
    const res = await golfStore.discountTrip(
      props.trip.id,
      discountAmount.value,
      discountReason.value || undefined
    )
    if (res) {
      await loadDiscounts()
      emit('refresh')
      discountAmount.value = 0
      discountReason.value = ''
    }
  } finally {
    isApplyingDiscount.value = false
  }
}

const confirmChangeAsset = async () => {
  if (!selectedAssetId.value) {
    return
  }
  isChangingAsset.value = true
  try {
    const res = await golfStore.changeTripAsset(props.trip.id, selectedAssetId.value)
    if (res) {
      ElMessage.success('Model successfully assigned to trip')
      assetDialogVisible.value = false
      emit('refresh')
    }
  } catch (err: any) {
    const msg = extractErrorMessage(err, 'Failed to assign model')
    ElMessage.error({ message: msg, duration: 6000, showClose: true })
  } finally {
    isChangingAsset.value = false
  }
}

const openTransactionsDialog = async () => {
  transactionsDialogVisible.value = true
  await loadTransactions()
}

const processPayment = async () => {
  if (!paymentAmount.value) {
    ElMessage.warning('Please enter an amount')
    return
  }

  const amount = parseFloat(paymentAmount.value)
  if (isNaN(amount) || amount <= 0) {
    ElMessage.warning('Please enter a valid amount')
    return
  }

  processingPayment.value = true
  try {
    const result = await golfStore.finishPayment(props.trip.id, {
      transaction_type: paymentType.value,
      action: paymentAction.value,
      amount,
    })
    if (result) {
      paymentAmount.value = ''
      emit('refresh')
      await loadTransactions()
    }
  } finally {
    processingPayment.value = false
  }
}

const getTransactionActionType = (action: string) => {
  switch (action) {
    case 'freeze':
      return 'warning'
    case 'charge':
      return 'success'
    case 'unfreeze':
    case 'refund':
      return 'info'
    default:
      return 'info'
  }
}

const formatAmount = (amount?: number) => {
  if (amount === undefined || amount === null) return '0.00'
  return amount.toFixed(2)
}

const formatDuration = (minutes?: number) => {
  if (!minutes) return ''
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  if (hours && mins) return `${hours}h ${mins}m`
  if (hours) return `${hours}h`
  return `${mins}m`
}

const formatPricingType = (type?: string) => {
  if (type === 'daily') return t('golf.trips.daily_rental')
  if (type === 'minute') return t('golf.trips.per_minute_rental')
  return t('golf.trips.hourly_rental')
}

const formatStatus = (status: string) => {
  const map: Record<string, string> = {
    pending: t('golf.trips.tab_pending'),
    approved: t('golf.trips.tab_approved'),
    ongoing: t('golf.trips.tab_ongoing'),
    on_hold: t('golf.trips.tab_on_hold'),
    completed: t('golf.trips.tab_completed'),
    cancelled_by_user: `${t('golf.trips.tab_cancelled')} (${t('golf.common.user')})`,
    cancelled_by_admin: `${t('golf.trips.tab_cancelled')} (${t('golf.common.admin')})`,
    cancelled_by_system: `${t('golf.trips.tab_cancelled')} (${t('golf.common.system')})`,
  }
  return map[status] || status
}

const getStatusType = (status: string) => {
  switch (status) {
    case 'pending':
      return 'warning'
    case 'approved':
      return 'success'
    case 'ongoing':
      return 'success'
    case 'on_hold':
      return 'warning'
    case 'completed':
      return 'success'
    case 'cancelled_by_user':
    case 'cancelled_by_admin':
    case 'cancelled_by_system':
      return 'danger'
    default:
      return 'info'
  }
}

const formatDate = (dateStr: string) => {
  if (!dateStr) return '—'
  return formatDateWithTime(dateStr, 'MMM dd, yyyy, HH:mm')
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["trip-info-section", ['lang-' + _unref(currentLanguage)]])
  }, [
    (_ctx.trip)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#golf-header-portal"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('golf.menu.trips')), 1),
              _createVNode(_component_el_icon, { class: "breadcrumb-separator" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowRight))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('golf.trips.trip_details')), 1),
              _createVNode(_component_el_icon, { class: "breadcrumb-separator" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowRight))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_5, "#" + _toDisplayString(_ctx.trip.id), 1),
              _createVNode(_component_el_tag, {
                type: getStatusType(_ctx.trip.status),
                effect: "light",
                class: "status-tag"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(formatStatus(_ctx.trip.status)), 1)
                ]),
                _: 1
              }, 8, ["type"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(renterName.value), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.trip.renter?.phone || '+994 50 123-4567'), 1)
          ]),
          (_ctx.trip.renter?.status === 'active')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[23] || (_cache[23] = _createElementVNode("img", {
                  src: "/icons_golf_module/Trip detailc Account verified.svg",
                  alt: "Verified",
                  style: {"width":"16px","height":"16px","margin-right":"4px"}
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.trips.account_verified')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (vehicleImage.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: vehicleImage.value,
                  alt: ""
                }, null, 8, _hoisted_15))
              : (_openBlock(), _createElementBlock("img", _hoisted_16))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(vehicleName.value || 'Denago XL (4 Seats)'), 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('golf.trips.model_id')) + ": " + _toDisplayString(_ctx.trip.asset?.asset_number ||
                  (_ctx.trip.asset?.id ? '#' + _ctx.trip.asset.id.slice(0, 8) : '—')), 1),
            (canChangeAsset.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "vehicle-change-link",
                  onClick: openChangeAssetDialog
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Edit))
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.trips.change_model_manually')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(formatPricingType(_ctx.trip.pricing_type)), 1),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('golf.trips.pickup')), 1),
              _createElementVNode("div", _hoisted_25, _toDisplayString(pickupDate.value), 1),
              _createElementVNode("div", _hoisted_26, _toDisplayString(pickupTime.value), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('golf.trips.return')), 1),
              _createElementVNode("div", _hoisted_29, [
                (hasExtension.value && originalReturnDate.value !== returnDate.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(originalReturnDate.value), 1),
                      _createVNode(_component_el_icon, { class: "extend-arrow" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Right))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(returnDate.value), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(returnDate.value), 1)
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_32, [
                (hasExtension.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(originalReturnTime.value), 1),
                      _createVNode(_component_el_icon, { class: "extend-arrow" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Right))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(returnTime.value), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(returnTime.value), 1)
                    ], 64))
              ]),
              (hasExtension.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.$t('golf.trips.extended_by_user')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (hasExtension.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _cache[24] || (_cache[24] = _createElementVNode("img", {
                  src: "/icons_golf_module/Trip details rental alert.svg",
                  alt: "Alert",
                  class: "alert-icon"
                }, null, -1)),
                _createElementVNode("div", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trip.extend_history, (ext, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "alert-text"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('golf.trips.trip_extended_user')) + " ", 1),
                      (ext.type === 'hourly' && ext.duration_minutes)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (+" + _toDisplayString(formatDuration(ext.duration_minutes)) + ") ", 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" (date range) ")
                          ], 64)),
                      _createTextVNode(" . " + _toDisplayString(_ctx.$t('golf.trips.additional_charge_applied')), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.trip.assigned_stall_number)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Location))
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.trips.assigned_stall')) + ": " + _toDisplayString(_ctx.trip.assigned_stall_number), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("button", {
            class: "btn-decline",
            disabled: !canDecline.value,
            onClick: openDeclineDialog
          }, _toDisplayString(_ctx.$t('golf.trips.decline')), 9, _hoisted_40),
          _createElementVNode("button", {
            class: "btn-approve",
            disabled: !canApprove.value,
            onClick: handleApprove
          }, _toDisplayString(_ctx.$t('golf.trips.approve')), 9, _hoisted_41),
          _createElementVNode("button", {
            class: "btn-finish",
            disabled: !canEnd.value,
            onClick: handleEnd
          }, _toDisplayString(_ctx.$t('golf.trips.complete_trip')), 9, _hoisted_42)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('golf.users.audit_documentation')), 1),
            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('golf.common.protocol_4point')), 1)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('golf.trips.pre_trip_verification')), 1),
              (_ctx.trip.pretrip_photos && _ctx.trip.pretrip_photos.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pretripPhotos.value, (photo, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "audit-img-box",
                        key: photo.angle
                      }, [
                        _createVNode(_component_el_image, {
                          src: photo.url,
                          "preview-src-list": pretripPhotos.value.map(p => p.url),
                          "initial-index": index,
                          fit: "cover",
                          "preview-teleported": ""
                        }, null, 8, ["src", "preview-src-list", "initial-index"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                      return _createElementVNode("div", {
                        class: "audit-empty-box",
                        key: i
                      })
                    }), 64))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('golf.trips.post_trip_return')), 1),
              (_ctx.trip.aftertrip_photos && _ctx.trip.aftertrip_photos.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aftertripPhotos.value, (photo, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "audit-img-box",
                        key: photo.angle
                      }, [
                        _createVNode(_component_el_image, {
                          src: photo.url,
                          "preview-src-list": aftertripPhotos.value.map(p => p.url),
                          "initial-index": index,
                          fit: "cover",
                          "preview-teleported": ""
                        }, null, 8, ["src", "preview-src-list", "initial-index"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                      return _createElementVNode("div", {
                        class: "audit-empty-box",
                        key: i
                      })
                    }), 64))
                  ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_56, [
        (_ctx.trip.payment_method === 'cash')
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("h5", _hoisted_59, [
                  _cache[25] || (_cache[25] = _createElementVNode("img", {
                    src: "/icons_golf_module/Trip details_cash.svg",
                    alt: "",
                    class: "title-icon"
                  }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.financial.settlement')) + " (" + _toDisplayString(_ctx.$t('golf.trips.cash')) + ") ", 1)
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("img", {
                  src: "/icons_golf_module/Trip details_cash big.svg",
                  alt: "",
                  class: "bg-icon"
                }, null, -1))
              ]),
              _createElementVNode("p", _hoisted_60, [
                _createTextVNode(" Manual desk reconciliation for " + _toDisplayString(['ongoing', 'on_hold'].includes(_ctx.trip.status) ? 'ongoing' : 'this') + " trip ", 1),
                _createElementVNode("span", _hoisted_61, "#" + _toDisplayString(_ctx.trip.id), 1),
                _cache[27] || (_cache[27] = _createTextVNode(". "))
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.trips.base_rental_service_fee')), 1),
                _createElementVNode("span", null, _toDisplayString(formatAmount(_ctx.trip.base_rate_amount)), 1)
              ]),
              (_ctx.trip.extend_history && _ctx.trip.extend_history.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.trips.accumulated_extensions')), 1),
                    _createElementVNode("span", null, _toDisplayString(formatAmount(_ctx.trip.extend_history.length * 18)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.trip.discount_amount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.promo.discount_value')), 1),
                    _createElementVNode("span", null, "-" + _toDisplayString(formatAmount(_ctx.trip.discount_amount)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.trips.trip_total')), 1),
                _createElementVNode("span", null, _toDisplayString(formatAmount(
                (_ctx.trip.base_rate_amount || 0) - (_ctx.trip.discount_amount || 0)
              )), 1)
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.trips.deposit')), 1),
                _createElementVNode("span", null, _toDisplayString(formatAmount(_ctx.trip.deposit_amount || 0)), 1)
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('golf.trips.total_cash_due')), 1),
                _createElementVNode("div", _hoisted_69, "₼" + _toDisplayString(formatAmount(totalDue.value)), 1)
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createVNode(_component_el_table, {
                  data: creditCardData.value,
                  size: "small",
                  style: {"width":"100%"},
                  class: "operations-table"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('golf.financial.operation_type'),
                      "min-width": "130"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", _hoisted_71, _toDisplayString(row.type), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('golf.financial.frozen'),
                      "min-width": "90"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["amount", { 'is-zero': !row.frozen }])
                        }, [
                          (row.frozen)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("₼ " + _toDisplayString(formatAmount(row.frozen)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(formatAmount(0)), 1)
                              ], 64))
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('golf.financial.charged'),
                      "min-width": "90"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["amount", { 'is-zero': !row.charged }])
                        }, [
                          (row.charged)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("₼ " + _toDisplayString(formatAmount(row.charged)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(formatAmount(0)), 1)
                              ], 64))
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('golf.financial.refunded'),
                      "min-width": "90"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["amount", { 'is-zero': !row.refunded }])
                        }, [
                          (row.refunded)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("₼ " + _toDisplayString(formatAmount(row.refunded)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(formatAmount(0)), 1)
                              ], 64))
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createElementVNode("div", _hoisted_72, [
                  _createVNode(_component_el_button, {
                    class: "transactions-btn",
                    onClick: openTransactionsDialog
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('golf.financial.transactions_title')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.$t('golf.financial.target_account')), 1),
                    _createVNode(_component_el_select, {
                      modelValue: paymentType.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paymentType).value = $event)),
                      class: "payment-select",
                      "popper-class": "golf-payment-dropdown"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: _ctx.$t('golf.trips.deposit'),
                          value: "deposit"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _ctx.$t('golf.financial.service_fee'),
                          value: "service"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('golf.financial.manual_amount')), 1),
                    _createVNode(_component_el_input, {
                      modelValue: paymentAmount.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentAmount).value = $event)),
                      type: "number",
                      class: "payment-amount-input"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t('golf.trips.trigger_action')), 1),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["pill-btn", { active: paymentAction.value === 'charge' }]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (paymentAction.value = 'charge'))
                      }, _toDisplayString(_ctx.$t('golf.financial.action_charge')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["pill-btn", { active: paymentAction.value === 'freeze' }]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (paymentAction.value = 'freeze'))
                      }, _toDisplayString(_ctx.$t('golf.financial.action_freeze')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["pill-btn", { active: paymentAction.value === 'unfreeze' }]),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (paymentAction.value = 'unfreeze'))
                      }, _toDisplayString(_ctx.$t('golf.financial.action_unfreeze')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["pill-btn", { active: paymentAction.value === 'refund' }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (paymentAction.value = 'refund'))
                      }, _toDisplayString(_ctx.$t('golf.financial.action_refund')), 3)
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: "finish-btn",
                  onClick: processPayment
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.trips.confirm_cash_settlement')), 1),
                  _createVNode(_component_el_icon, { class: "finish-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Right))
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("h5", _hoisted_85, [
                  _cache[28] || (_cache[28] = _createElementVNode("img", {
                    src: "/icons_golf_module/Trip details card.svg",
                    alt: "",
                    class: "title-icon"
                  }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.financial.settlement')) + " (" + _toDisplayString(_ctx.$t('golf.trips.credit')) + ") ", 1)
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("img", {
                  src: "/icons_golf_module/Trip details card big.svg",
                  alt: "",
                  class: "bg-icon"
                }, null, -1))
              ]),
              _createElementVNode("p", _hoisted_86, [
                _createTextVNode(" Manual desk reconciliation for " + _toDisplayString(['ongoing', 'on_hold'].includes(_ctx.trip.status) ? 'ongoing' : 'this') + " trip ", 1),
                _createElementVNode("span", _hoisted_87, "#" + _toDisplayString(_ctx.trip.id), 1),
                _cache[30] || (_cache[30] = _createTextVNode(". "))
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.trips.base_rental_service_fee')), 1),
                _createElementVNode("span", null, _toDisplayString(formatAmount(_ctx.trip.base_rate_amount)), 1)
              ]),
              (_ctx.trip.discount_amount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.promo.discount_value')), 1),
                    _createElementVNode("span", null, "-" + _toDisplayString(formatAmount(_ctx.trip.discount_amount)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.trips.trip_total')), 1),
                _createElementVNode("span", null, _toDisplayString(formatAmount(
                (_ctx.trip.base_rate_amount || 0) - (_ctx.trip.discount_amount || 0)
              )), 1)
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.trips.deposit')), 1),
                _createElementVNode("span", null, _toDisplayString(formatAmount(_ctx.trip.deposit_amount)), 1)
              ]),
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.$t('golf.trips.total_credit_due')), 1),
                _createElementVNode("div", _hoisted_94, "₼" + _toDisplayString(formatAmount(totalDue.value)), 1)
              ]),
              _createElementVNode("div", _hoisted_95, [
                _createVNode(_component_el_table, {
                  data: creditCardData.value,
                  size: "small",
                  style: {"width":"100%"},
                  class: "operations-table"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('golf.financial.operation_type'),
                      "min-width": "130"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", _hoisted_96, _toDisplayString(row.type), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('golf.financial.frozen'),
                      "min-width": "90"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["amount", { 'is-zero': !row.frozen }])
                        }, [
                          (row.frozen)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("₼ " + _toDisplayString(formatAmount(row.frozen)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(formatAmount(0)), 1)
                              ], 64))
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('golf.financial.charged'),
                      "min-width": "90"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["amount", { 'is-zero': !row.charged }])
                        }, [
                          (row.charged)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("₼ " + _toDisplayString(formatAmount(row.charged)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(formatAmount(0)), 1)
                              ], 64))
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('golf.financial.refunded'),
                      "min-width": "90"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["amount", { 'is-zero': !row.refunded }])
                        }, [
                          (row.refunded)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("₼ " + _toDisplayString(formatAmount(row.refunded)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(formatAmount(0)), 1)
                              ], 64))
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createElementVNode("div", _hoisted_97, [
                  _createVNode(_component_el_button, {
                    class: "transactions-btn",
                    onClick: openTransactionsDialog
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('golf.financial.transactions_title')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.$t('golf.financial.target_account')), 1),
                    _createVNode(_component_el_select, {
                      modelValue: paymentType.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((paymentType).value = $event)),
                      class: "payment-select",
                      "popper-class": "golf-payment-dropdown"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: _ctx.$t('golf.trips.deposit'),
                          value: "deposit"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _ctx.$t('golf.financial.service_fee'),
                          value: "service"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.$t('golf.financial.manual_amount')), 1),
                    _createVNode(_component_el_input, {
                      modelValue: paymentAmount.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((paymentAmount).value = $event)),
                      type: "number",
                      class: "payment-amount-input"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.$t('golf.trips.trigger_action')), 1),
                    _createElementVNode("div", _hoisted_107, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["pill-btn", { active: paymentAction.value === 'charge' }]),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (paymentAction.value = 'charge'))
                      }, _toDisplayString(_ctx.$t('golf.financial.action_charge')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["pill-btn", { active: paymentAction.value === 'freeze' }]),
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (paymentAction.value = 'freeze'))
                      }, _toDisplayString(_ctx.$t('golf.financial.action_freeze')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["pill-btn", { active: paymentAction.value === 'unfreeze' }]),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (paymentAction.value = 'unfreeze'))
                      }, _toDisplayString(_ctx.$t('golf.financial.action_unfreeze')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["pill-btn", { active: paymentAction.value === 'refund' }]),
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (paymentAction.value = 'refund'))
                      }, _toDisplayString(_ctx.$t('golf.financial.action_refund')), 3)
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: "finish-btn",
                  onClick: processPayment
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.trips.finish_log_transaction')), 1),
                  _createVNode(_component_el_icon, { class: "finish-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Right))
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: declineDialogVisible.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((declineDialogVisible).value = $event)),
      title: _ctx.$t('golf.trips.decline'),
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (declineDialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: confirmDecline,
          loading: isDeclining.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.trips.decline')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('golf.common.reason')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: declineReason.value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((declineReason).value = $event)),
                  type: "textarea",
                  rows: 3,
                  placeholder: _ctx.$t('golf.common.reason')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: discountDialogVisible.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((discountDialogVisible).value = $event)),
      title: _ctx.$t('golf.trips.discounts_applied'),
      width: "520px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (discountDialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.common.close')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmDiscount,
          loading: isApplyingDiscount.value,
          disabled: discountAmount.value <= 0
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.promo.add_discount')), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("section", _hoisted_109, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('golf.promo.add_discount')), 1),
            _createElementVNode("div", _hoisted_110, [
              _createVNode(_component_el_form, { "label-width": "120px" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('golf.common.amount'),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: discountAmount.value,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((discountAmount).value = $event)),
                        min: 0,
                        precision: 2,
                        max: props.trip.total_amount,
                        class: "amount-input"
                      }, null, 8, ["modelValue", "max"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('golf.common.reason')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: discountReason.value,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((discountReason).value = $event)),
                        type: "textarea",
                        rows: 3,
                        placeholder: _ctx.$t('golf.common.reason')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_el_divider),
          _createElementVNode("section", _hoisted_111, [
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('golf.trips.discounts_applied')), 1),
              (discounts.value.length)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "info",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(discounts.value.length) + " total ", 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (loadingDiscounts.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                  _createVNode(_component_el_skeleton, {
                    rows: 3,
                    animated: ""
                  })
                ]))
              : (!discounts.value.length)
                ? (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    description: "No discounts applied yet",
                    "image-size": 80
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_114, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(discounts.value, (discount) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: discount.id,
                        class: "discount-item"
                      }, [
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.$t('golf.promo.discount_value')), 1),
                          _createElementVNode("span", _hoisted_117, "₼" + _toDisplayString(formatAmount(discount.amount)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("div", _hoisted_119, _toDisplayString(formatDiscountDate(discount.applied_at)), 1),
                          (discount.admin_id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "admin-label" }, "Admin ID", -1)),
                                _createElementVNode("span", _hoisted_121, _toDisplayString(discount.admin_id), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (discount.reason)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.$t('golf.common.reason')), 1),
                                _createElementVNode("span", _hoisted_124, _toDisplayString(discount.reason), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_el_button, {
                          class: "remove-btn",
                          type: "danger",
                          plain: "",
                          size: "small",
                          loading: removingDiscountId.value === discount.id,
                          onClick: ($event: any) => (removeDiscount(discount.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('golf.common.delete')), 1)
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"])
                      ]))
                    }), 128))
                  ]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: assetDialogVisible.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((assetDialogVisible).value = $event)),
      title: _ctx.$t('golf.trips.change_model_manually'),
      width: "480px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[20] || (_cache[20] = ($event: any) => (assetDialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmChangeAsset,
          loading: isChangingAsset.value,
          disabled: !selectedAssetId.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.trips.assign_model')), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-position": "top" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('golf.trips.select_model_catalog'),
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: selectedAssetId.value,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((selectedAssetId).value = $event)),
                  placeholder: _ctx.$t('golf.trips.select_available_model_placeholder'),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableAssets.value, (asset) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: asset.id,
                        label: asset.label,
                        value: asset.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_125, [
                            _createElementVNode("span", _hoisted_126, _toDisplayString(asset.asset_number || '#' + asset.id.slice(0, 8)), 1),
                            _createElementVNode("span", _hoisted_127, _toDisplayString(asset.make_name) + _toDisplayString(asset.stall_number
                      ? ' · ' +
                        _ctx.$t('golf.trips.stall') +
                        ' ' +
                        asset.stall_number
                      : ''), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]),
                _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.$t('golf.trips.showing_active_models_fleet')), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: transactionsDialogVisible.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((transactionsDialogVisible).value = $event)),
      title: _ctx.$t('golf.financial.recent_transactions'),
      width: "70%"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: transactions.value,
          size: "small",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('golf.trips.trigger_action'),
              width: "110"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tag, {
                  type: getTransactionActionType(row.action),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.action.toUpperCase()), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: _ctx.$t('golf.financial.operation_type'),
              width: "110"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('golf.financial.manual_amount'),
              width: "120"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(" ₼" + _toDisplayString(formatAmount(row.amount)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "description",
              label: _ctx.$t('golf.common.description')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('golf.financial.col_timestamp'),
              width: "160"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(formatDate(row.created_at)), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, loadingTransactions.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 2))
}
}

})